import { APIModel, APIModelHandler, APIModelImpl } from '../../../../../toolkit/uicomponentapimodel';
import { ToneDto } from '../../../../../../core/dto/tonedto';
import { AddToWishlistDtoImpl } from '../../../../../../core/dto/wishlist/addtowishlist/addtowishlistdto';
import { AddToWishlistResponse } from '../../../../../../core/api/wishlist/addtowishlist/addtowishlistresponse';
import { AddToWishlistRequestImpl } from '../../../../../../core/api/wishlist/addtowishlist/addtowishlistrequest';
import { DeleteToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/deletetone/deletetonedto';
import { DeleteToneResponse } from 'src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetoneresponse';
import { DeleteToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetonerequest';
import { PasswordValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/passwordvalidation/passwordvalidationrequest';
import { PasswordValidationResponse } from 'src/com/sixdee/crbtportal/core/api/passwordvalidation/passwordvalidationresponse';
import { SecurityTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenrequest';
import { SecurityTokenResponse } from 'src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenresponse';
import { LoginDto } from 'src/com/sixdee/crbtportal/core/dto/login/logindto';
import { PasswordValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/passwordvalidation/passwordvalidationdto';
import { SecurityTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/securitytoken/securitytokendto';
import { LoginProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/loginprocessorfactory';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { RsaService } from 'src/com/sixdee/crbtportal/utils/rsaservice';

export interface ToneCardAPIModel extends APIModel
{
  doLogin(loginDto: LoginDto): void;
    addToWishlist(toneDto: ToneDto): void;
    deleteTone(toneDto: ToneDto): void;
}

export class ToneCardAPIModelImpl extends APIModelImpl implements ToneCardAPIModel
{
  private loginProcessorFactory: LoginProcessorFactory;

  constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) {
      super(applicationContext, apiModelHandler);

      this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
  }
      deleteTone(toneDto: ToneDto): void 
      {
        /* this.getAPIModelHandler().onSuccess("", 
            "", ""); */

            let deleteToneDto = new DeleteToneDtoImpl();
            deleteToneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteToneDto.setToneId(toneDto.getId());
            deleteToneDto.setPackName(this.getContext().getUserContext().getPackName());

            this.getAPIProcesssorFactory().getToneProcessorFactory()
            .getDelteTone()
            .success((deleteToneResponse: DeleteToneResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), deleteToneResponse);
              
              })
            .failure((deleteToneResponse: DeleteToneResponse)=>
              {
                this.getAPIModelHandler().onFailure(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), undefined);
              })
            .execute(new DeleteToneRequestImpl(deleteToneDto));    
      }
     addToWishlist(toneDto: ToneDto): void 
     { 
             let addToWishlistDto = new AddToWishlistDtoImpl();
             addToWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
             addToWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
             addToWishlistDto.setIdentifier("AddToWishList");
             addToWishlistDto.setContentId(toneDto.getId());
             addToWishlistDto.setContentName(toneDto.getToneName());
             addToWishlistDto.setPath(toneDto.getToneUrl());
             addToWishlistDto.setPreviewImage(toneDto.getImgPath());
             addToWishlistDto.setAlbum(toneDto.getAlbumName());
             addToWishlistDto.setArtist(toneDto.getArtistName());
             addToWishlistDto.setPrice(String(toneDto.getPrice()));
             addToWishlistDto.setWishlistType("1");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getAddToWishlist()
             .success((addToWishlistResponse: AddToWishlistResponse)=>
             {
                 this.getAPIModelHandler().onSuccess(addToWishlistResponse.getAPIFeature(), 
                 addToWishlistResponse.getDescription(), addToWishlistResponse);
               
              })
             .failure((addToWishlistResponse: AddToWishlistResponse)=>
              {
                this.getAPIModelHandler().onFailure(addToWishlistResponse.getAPIFeature(), 
                addToWishlistResponse.getDescription(), undefined);
              })
             .execute(new AddToWishlistRequestImpl(addToWishlistDto));
     } 

     doLogin(loginDto: LoginDto): void 
     {
     let securityTokenDto: SecurityTokenDtoImpl = new SecurityTokenDtoImpl();
         this.loginProcessorFactory.getSecurityToken()
             .success((securityTokenResponse: SecurityTokenResponse) => {
                 this.validatePassword(loginDto, securityTokenResponse.getSecurityCounter());
             })
             .failure((securityTokenResponse: SecurityTokenResponse) => 
             {
                 this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(),
                     securityTokenResponse.getDescription(), securityTokenResponse);
             })
             .execute(new SecurityTokenRequestImpl(securityTokenDto));
     }
     
    
     validatePassword(loginDto: LoginDto, securityToken: string) {
         let passwordValidationDto = new PasswordValidationDtoImpl();
 
         let encryptedPassword = RsaService.getInstance(this.getContext().getProperty())
         .encryptWithNodeRSA(loginDto.getPassword() + securityToken);
 
         passwordValidationDto.setMsisdn(loginDto.getMsisdn());
         passwordValidationDto.setEncryptedPassword(encryptedPassword);
         passwordValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());
         passwordValidationDto.setSecurityCounter(securityToken);
 
         this.loginProcessorFactory.validatePassword()
             .success((passwordValidationResponse: PasswordValidationResponse) => 
             {
                 this.getAPIModelHandler().onSuccess(passwordValidationResponse.getAPIFeature(),
                 loginDto.getMsisdn(), passwordValidationResponse);
             })
             .failure((passwordValidationResponse: PasswordValidationResponse) => {
                 this.getAPIModelHandler().onFailure(passwordValidationResponse.getAPIFeature(),
                     passwordValidationResponse.getDescription(), passwordValidationResponse);
             })
             .execute(new PasswordValidationRequestImpl(passwordValidationDto));
     }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonecardapimodel.tsx